import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore"
import { POTENCIA_MINIMA_ENGENHARIA, POTENCIA_MINIMA_VERTICAL } from "../constants"
import { isMobile } from "./deviceUtils"
import { FlatButton } from "src/framework/components/buttons/FlatButton"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"

interface RedirecionarParaProjetoVerticalProps {
  onNegation: () => void
  yesText: string
}

export function redirecionarParaProjetoVertical({ onNegation, yesText }: RedirecionarParaProjetoVerticalProps) {
  const permissoes:string[] = PermissionUtil.getPermissions();
  const customButtons: JSX.Element = isMobile() ? (<>
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: '100%',
      }}
    >
      { PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_ESPECIAL, permissoes) && (
        <FlatButton
          style={{ width: '100%' }}
          variant="outlined"
          color="secondary"
          text="IR PARA VERTICAIS"
          onClick={()=>{
            confirmationDialog.close()
            if (typeof onNegation === 'function') onNegation()
          }}
        />
      )}

      <FlatButton
        style={{ width: '100%' }}
        variant="contained"
        color="primary"
        text={yesText}
        onClick={()=>{
          confirmationDialog.close()
        }}
      />
    </div>
  </>) : (<>
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 12,
        width: '100%',
      }}
    >
      { PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_ESPECIAL, permissoes) && (
        <FlatButton
          variant="outlined"
          color="secondary"
          text="IR PARA VERTICAIS"
          onClick={()=>{
            confirmationDialog.close()
            if (typeof onNegation === 'function') onNegation()
          }}
        />
      )}

      <FlatButton
        variant="contained"
        color="primary"
        text={yesText}
        onClick={()=>{
          confirmationDialog.close()
        }}
      />
    </div>
  </>)
  confirmationDialog.setup({
    title: 'Atenção!',
    subtitle: 'Projetos verticais',
    content: (
      <>
        <p>Projetos que somente possuem produtos acima de {POTENCIA_MINIMA_VERTICAL} kWp até {POTENCIA_MINIMA_ENGENHARIA} kWp podem ser dimensionados na plataforma.</p>
        <p>Projetos com potência acima de {POTENCIA_MINIMA_VERTICAL} kWp com serviço adicionado ou turnkey devem ser registrados em Projetos Verticais da Intelbras.</p>
        <span>Caso tenha dúvidas, entre em contato com nossa equipe:</span><br/>
        <span>E-mail: <a href={`mailto:projetos_solar@intelbras.com.br`}>projetos_solar@intelbras.com.br</a></span>
      </>
    ),
    onClose: () => {
      confirmationDialog.close()
    },
    onNegation: () => {
      confirmationDialog.close()
      if (typeof onNegation === 'function') onNegation()
    },
    onConfirmation: () => {
      confirmationDialog.close()
    },
    customButtons: customButtons,
  })

  confirmationDialog.open()
}